<template>
	<v-sparkline
		:auto-draw="autoDraw"
		:auto-draw-duration="autoDrawDuration"
		:auto-draw-easing="autoDrawEasing"
		:auto-line-width="autoLineWidth"
		:color="color"
		:fill="fill"
		:height="height"
		:label-size="labelSize"
		:labels="labels"
		:padding="padding"
		:show-labels="showLabels"
		:smooth="smooth"
		:type="type"
		:value="value"
		:width="width"
	/>
</template>

<script>
export default {
	props: {
		autoDraw: {
			type: Boolean,
			default: false,
		},
		autoDrawDuration: {
			type: Number,
			default: 500,
		},
		autoDrawEasing: {
			type: String,
			default: 'ease',
		},
		autoLineWidth: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'secondary',
		},
		fill: {
			type: Boolean,
			default: true,
		},
		height: {
			type: [Number, String],
			default: 75,
		},
		labelSize: {
			type: [Number, String],
			default: 7,
		},
		labels: {
			type: Array,
			default: () => [],
		},
		padding: {
			type: [Number, String],
			default: 8,
		},
		showLabels: {
			type: Boolean,
			default: false,
		},
		smooth: {
			type: [Boolean, Number, String],
			default: 2,
		},
		// trend|bar
		type: {
			type: String,
			default: 'trend',
		},
		value: {
			type: Array,
			default: () => [],
		},
		width: {
			type: [Number, String],
			default: 300,
		},
	},
}
</script>
